import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { getOrderSummaryQueryKey } from '../../../services/modules/order/order.keys';
import { WithId } from '../../../types/Base.types';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { getOrderCalculateUrlParams } from '../utils/orderCalculate.utils';

const useCalculateSummary = () => {
  const queryClient = useQueryClient();
  const params = useParams<WithId>();
  const location = useLocation();
  const { team } = useApplicationContext();

  const urlParams = useMemo(
    () => getOrderCalculateUrlParams(location.search).urlParams,
    [location.search],
  );

  const calculateSummary = useCallback(async () => {
    const queryKey = getOrderSummaryQueryKey({
      orderId: params.id,
      urlParams: urlParams?.toString(),
    });

    await queryClient.refetchQueries({
      type: 'active',
      queryKey: [team?.id, ...queryKey],
    });
  }, [params.id, urlParams, queryClient, team]);

  return { calculateSummary };
};

export default useCalculateSummary;
